import {
    ConfigurationItemArrayEditor,
    configurationItemArrayEditorRules,
} from '@client/components/_core/configuration/ConfigurationItemArrayEditor';
import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { Col, Row } from 'antd';
import { FileText } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/general/documents')({
    staticData: {
        metadata: {
            title: 'Document types',
        },
        ui: {
            icon: FileText,
            title: 'Document types',
            subtitle: 'Upload document types for complaints, incidents and conflicts of interest',
            menuDescription: 'Upload document types for complaints, incidents and conflicts of interest',
        },
    },
    component: Documents,
});

function Documents() {
    return (
        <PageController route={Route}>
            <Row gutter={[16, 16]}>
                <Col span={12}>
                    <ConfigurationItemArrayEditor
                        title="Complaint document types"
                        settingToEdit="COMPLAINT_UPLOAD_DOCUMENT_TYPES"
                        description="Rename, add or remove an upload document type."
                        minItems={1}
                        arrayRules={[configurationItemArrayEditorRules.uniqueItems]}
                        itemRules={[{ required: true, message: 'Field is required' }]}
                        className="h-full"
                    />
                </Col>
                <Col span={12}>
                    <ConfigurationItemArrayEditor
                        title="Incident document types"
                        settingToEdit="INCIDENT_UPLOAD_DOCUMENT_TYPES"
                        description="Rename, add or remove an upload document type."
                        minItems={1}
                        arrayRules={[configurationItemArrayEditorRules.uniqueItems]}
                        itemRules={[{ required: true, message: 'Field is required' }]}
                        className="h-full"
                    />
                </Col>
                <Col span={12}>
                    <ConfigurationItemArrayEditor
                        title="Conflict of interest document types"
                        settingToEdit="COI_UPLOAD_DOCUMENT_TYPES"
                        description="Rename, add or remove an upload document type."
                        minItems={1}
                        arrayRules={[configurationItemArrayEditorRules.uniqueItems]}
                        itemRules={[{ required: true, message: 'Field is required' }]}
                        className="h-full"
                    />
                </Col>
            </Row>
        </PageController>
    );
}
